module.exports = __webpack_public_path__ + "easydial.2a5e25f6ba8ec7e6a78f.jpg";